<template>
  <v-app
    :style="{
      background: setBackgoundBox(),
      'background-attachment': 'fixed !important',
    }"
  >
    <v-container v-if="this.$route.name == 'main'" data-aos="slide-up">
      <v-card
        class="d-flex align-center fixed-card"
        elevation="0"
        style="border-radius: 8px; background-color: transparent"
      >
        <v-row class="">
          <v-col cols="12" md="12" class="pb-0">
            <div class="d-flex align-center justify-space-between">
              <div
                v-if="is_use_main_page_search"
                style="width: 100%"
                @click="$router.push({ name: 'search' })"
              >
                <v-text-field
                  outlined
                  dense
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  :label="$t('searchMissionOrReward')"
                  style="border-radius: 20px; background-color: #ffffff"
                ></v-text-field>
              </div>
              <div
                v-else
                class="d-flex align-center pl-2 pr-3"
                style="
                  height: 32px;
                  border-radius: 16px;
                  background-color: #ffffffa6;
                  border: 2px solid #ffffffcc;
                  gap: 8px;
                "
              >
                <v-icon size="20" :color="greetingMessage.color">
                  {{ greetingMessage.icon }}</v-icon
                >
                <p
                  class="mb-0"
                  style="font-weight: 500"
                  :style="{
                    color: greetingMessage.color,
                  }"
                >
                  {{ greetingMessage.label }}
                </p>
              </div>
              <SelectLangauge />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <router-view />
    <BottomNavbar v-if="showBottomNavbar" />
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import BottomNavbar from "./BottomNavbar.vue";
import SelectLangauge from "../../components/selectLangauge.vue";
import { adjustHslBrightness } from "../../config/general-function";

export default {
  name: "Blanklayout",
  components: {
    BottomNavbar,
    SelectLangauge,
  },
  data: () => {
    return {
      is_use_main_page_search: true,
    };
  },
  created() {
    this.changeWebsiteFont(this.site?.display_setting?.app_font);
    this.is_use_main_page_search = [null, undefined].includes(
      this.site?.display_setting?.is_use_main_page_search
    )
      ? true
      : this.site?.display_setting?.is_use_main_page_search;
  },
  methods: {
    setBackgoundBox() {
      const _color = this.site?.display_setting?.background_color || null;
      const bg_url = this.site?.display_setting?.background_url || null;
      let _style = "#fafafa";
      if (
        this.site?.display_setting?.background_type == "color_gradient" &&
        _color
      ) {
        const darken = adjustHslBrightness(_color, -20);
        _style = `linear-gradient(120deg, ${_color}, ${darken}) !important`;
      }
      if (this.site?.display_setting?.background_type == "image" && bg_url) {
        _style = `url("${bg_url}") center / cover no-repeat !important`;
      }
      if (
        this.site?.display_setting?.background_type == "color_plain" &&
        _color
      ) {
        _style = _color;
      }
      return _style;
    },
    changeWebsiteFont(fontNames) {
      let fontName = "";
      if (Array.isArray(fontNames)) {
        fontName = fontNames.map((font) => `"${font}"`).join(", ");
      } else {
        fontName = fontNames;
      }
      let _fontName = fontName || "Default";
      if (["Default", '"Default"'].includes(_fontName)) {
        document.documentElement.style.setProperty("--dynamic-font", "");
      } else {
        document.documentElement.style.setProperty("--dynamic-font", _fontName);
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    greetingMessage() {
      const darken = adjustHslBrightness(this.site?.color || "#ffffff", -50);
      let detail = {
        label: "textGoodMorning",
        icon: "mdi-weather-sunny",
        color: darken,
      };
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 12) {
        detail.label = "textGoodMorning";
        detail.icon = "mdi-weather-sunny";
      } else if (hour >= 12 && hour < 17) {
        detail.label = "textGoodAfternoon";
        detail.icon = "mdi-weather-partly-cloudy";
      } else if (hour >= 17 && hour < 21) {
        detail.label = "textGoodEvening";
        detail.icon = "mdi-weather-sunset";
      } else {
        detail.label = "textGoodNight";
        detail.icon = "mdi-weather-night";
      }
      detail.label = this.$t(detail.label);
      return detail;
    },
  },
  watch: {},
};
</script>

<style>
.fixed-card {
  position: relative;
}
.fixed-row {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
</style>
